/**
 * src/staffChoice.js
 *
 * Which staff choices a service offers on the booking page. MIRRORS
 * api/shared/staff-choice.js (which booking-create enforces) — change together.
 *
 *   allowSpecific — false when Bookings says customers can't choose staff
 *     (schedulingPolicy.allowStaffSelection === false, else the business's —
 *     the page gets it as service.businessAllowStaffSelection) and
 *     settings.availability.honorBookingsStaffSelection isn't turned off.
 *   allowAnyone   — settings.availability.anyoneAvailable ("show" | "hide"),
 *     per-service anyoneAvailableByService; always true when a specific
 *     person can't be picked.
 */

const ANYONE_AVAILABLE_MODES = ["show", "hide"];

export function resolveStaffChoice(settings, service, business) {
  const a = settings?.availability || {};
  const serviceMode = service?.id ? a.anyoneAvailableByService?.[service.id] : undefined;
  const mode = ANYONE_AVAILABLE_MODES.includes(serviceMode) ? serviceMode
    : ANYONE_AVAILABLE_MODES.includes(a.anyoneAvailable) ? a.anyoneAvailable
    : "show";
  // Bookings' "Let customers choose staff": the service's own policy, else the
  // business-wide one (a service with no policy of its own uses the business's).
  const own = service?.schedulingPolicy?.allowStaffSelection;
  const bookingsAllows = typeof own === "boolean" ? own : business?.schedulingPolicy?.allowStaffSelection;
  const allowSpecific = !(a.honorBookingsStaffSelection !== false && bookingsAllows === false);
  return { allowSpecific, allowAnyone: !allowSpecific || mode === "show" };
}
